import React, { useContext, useState } from 'react'
import moment from 'moment'
import DetailsBox from '../../../../../components/Cards/DetailsBox'
import API from '../../../../../services/API'
import { GlobalContext } from '../../../../../App'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Stack from '@mui/material/Stack'
import TextField from '@mui/material/TextField'
import Tooltip from '@mui/material/Tooltip'
import SendIcon from '@mui/icons-material/Send'

const PostEventAnalysis = ({ event, setEvent }) => {
  const [feedback, setFeedback] = useState(
    event?.postEventAnalysis?.clientFeedback ?? ''
  )

  const { setToast } = useContext(GlobalContext)

  const handleFeedbackSubmission = () => {
    API.post('/client-portal/eventfeedback/' + event._id, {
      feedback,
    }).then((res) => {
      if (res.status === 200) {
        setEvent((prev) => ({
          ...prev,
          postEventAnalysis: {
            ...prev.postEventAnalysis,
            clientFeedback: feedback,
          },
        }))
        setToast({ message: 'Feedback Submitted - Thank you!' })
      }
    })
  }

  return (
    moment(event.startDate).isBefore(moment().subtract(1, 'hour')) && (
      <Grid item xs={12}>
        <DetailsBox title="Post Event Analysis">
          <Stack gap={1}>
            {!event?.postEventAnalysis?.peaAvailableToCustomer && (
              <Alert severity="info">
                PEA is not yet available for this event.
              </Alert>
            )}
            <Stack
              direction={{ xs: 'column', lg: 'row' }}
              gap={{ xs: 0, lg: 1 }}
            >
              <Stack flexGrow={1}>
                <TextField
                  value={feedback}
                  onChange={(e) => setFeedback(e.target.value)}
                  multiline
                  minRows={2}
                  label="Event Organiser Feedback"
                  placeholder="Enter your feedback here"
                  helperText="Your feedback is invaluable to us, and allows us to build a
                robust post event analysis that will strengthen our medical plan
                at your future events."
                />
              </Stack>
              <Button
                onClick={handleFeedbackSubmission}
                variant="contained"
                color="success"
                disabled={
                  feedback === event?.postEventAnalysis?.clientFeedback ||
                  feedback === ''
                }
              >
                <Tooltip title="Submit Feedback">
                  <SendIcon />
                </Tooltip>
              </Button>
            </Stack>
          </Stack>
        </DetailsBox>
      </Grid>
    )
  )
}

export default PostEventAnalysis
